<h2 mat-dialog-title>Importer un site manuellement</h2>

<mat-dialog-content>
    <form [formGroup]="site" (ngSubmit)="createSite(true)">
        <div class="flex flex-row gap-2">
            <mat-form-field class="w-full">
                <mat-label>Nom site</mat-label>
                <input 
                    matInput 
                    type="text" 
                    formControlName="name"
                    placeholder="CARREFOUR RENNES"
                >
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>Réf. Site</mat-label>
                <input 
                    matInput 
                    type="text" 
                    formControlName="reference"
                    placeholder="CS8394021"
                >
            </mat-form-field>
        </div>

        <div formGroupName="sourceAddress">
            <mat-form-field class="w-full">
                <mat-label>Adresse</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="address"
                    placeholder="32 RUE DU PORT, 63000 CLERMONT-FERRAND"
                >
            </mat-form-field>

            <div class="flex flex-row gap-2">
                <mat-form-field class="w-full">
                    <mat-label>Coordonnées</mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="coordinates"
                        placeholder="45.780297, 3.088933"
                    >
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>Code immeuble</mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="fibre_building_code"
                        placeholder="IMB/63113/C/T7N1"
                    >
                </mat-form-field>
            </div>

            @if (site.controls.sourceAddress.hasError('atLeastOneRequired') && site.controls.sourceAddress.touched) {
                <mat-error class="text-sm">Veuillez renseigner une adresse, des coordonnées ou un code immeuble.</mat-error>
            }
        </div>

        <!-- Totally secret button so that pressing enter submits the form -->
        <button type="submit" class="hidden"></button>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]>Annuler</button>

    <button mat-stroked-button  [disabled]="isCreatingSite() || site.invalid" (click)="createSite(false)">
        @if (isCreatingSite()) {
            <i class="spinner-btn custom-spinner"></i>
        } @else {
            Enregistrer et ajouter un autre
        }
    </button>

    <button mat-stroked-button  [disabled]="isCreatingSite() || site.invalid" (click)="createSite(true)">
        @if (isCreatingSite()) {
            <i class="spinner-btn custom-spinner"></i>
        } @else {
            Enregistrer et fermer
        }
    </button>
</mat-dialog-actions>